import React, { useState } from 'react';
import { FaEarthAsia, FaRegCopy } from 'react-icons/fa6';
import { languages, getFlagUrl } from '../utils/languages';
import { convertAmount } from '../utils/converter';

const MultiLangReference = ({ amount, onCopy }) => {
  const [activeTab, setActiveTab] = useState('eastAsia');

  // Helper to render a language card
  const LanguageCard = ({ lang }) => {
    const result = convertAmount(amount, lang.code);
    return (
      <div className="p-3.5 bg-white/70 dark:bg-neutral-800/70 rounded-lg border border-gray-200 dark:border-neutral-700 transition-all hover:shadow-md">
        <div className="flex items-center justify-between mb-2">
            <div className="flex items-center">
                <img src={getFlagUrl(lang.flag)} alt={lang.code} className="w-5 h-3.5 object-cover rounded-sm mr-2 shadow-sm" />
                <span className="text-sm font-medium text-gray-700 dark:text-gray-200">{lang.name}</span>
            </div>
            <button 
                onClick={() => onCopy(result)}
                className="text-gray-400 hover:text-primary-600 dark:hover:text-primary-400 transition-colors"
                title="Copy"
            >
                <FaRegCopy />
            </button>
        </div>
        <p className={`text-gray-800 dark:text-gray-200 text-sm ${lang.rtl ? 'text-right' : ''} ${lang.font === 'korean' ? 'font-korean' : ''}`}>
            {result}
        </p>
      </div>
    );
  };

  return (
    <div className="glass-card rounded-xl shadow-lg overflow-hidden animate-fade-in mb-8">
        <div className="h-1 w-full bg-gradient-to-r from-secondary-400 via-accent-400 to-primary-400"></div>
        
        <div className="p-6 md:p-8">
            <div className="flex flex-col sm:flex-row sm:items-center justify-between mb-6 gap-4">
                <h2 className="text-xl font-semibold text-gray-800 dark:text-gray-100 flex items-center">
                    <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-accent-100 dark:bg-accent-900/30 text-accent-600 dark:text-accent-400 mr-3">
                        <FaEarthAsia />
                    </span>
                    多語言參考
                </h2>
                
                <div className="flex bg-gray-100 dark:bg-neutral-800 p-1 rounded-lg self-start sm:self-auto">
                    {['eastAsia', 'europe', 'others'].map((tab) => (
                        <button
                            key={tab}
                            onClick={() => setActiveTab(tab)}
                            className={`px-3 py-1.5 text-xs font-medium rounded-md transition-all ${
                                activeTab === tab 
                                ? 'bg-white dark:bg-neutral-700 text-primary-600 dark:text-primary-400 shadow-sm' 
                                : 'text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200'
                            }`}
                        >
                            {tab === 'eastAsia' ? '東亞' : tab === 'europe' ? '歐洲' : '其他'}
                        </button>
                    ))}
                </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {languages[activeTab].map(lang => (
                    <LanguageCard key={lang.code} lang={lang} />
                ))}
            </div>
        </div>
    </div>
  );
};

export default MultiLangReference;